import React from "react"
import Helmet from "react-helmet"
import Seo from "components/seo"
import Layout from "components/layout"
// import LayoutGeneralPage from "components/layout-general-page"
// import { getServerAuthenticated } from "lib/utils/get-sever-authentication"
import AboutComp from "@components/pages/about"
import ExportHistory from "@components/pages/about/export-history"
import HandmadeComp from "@components/pages/about/handmade"
import SustainComp from "@components/pages/about/sustain"
import { useScrollAnim, useWindowSize } from "components/hooks/hooks"
import { useRouter } from "next/router"
import { Breadcrumb } from "@components/anti"

const AboutPage = ({ locale, locales }) => {
  return (
    <>
      <Seo title="About" />
      <Helmet>
        <body className="bd-about" />
      </Helmet>
      <Layout>
        <AboutComp locale={locale} locales={locales} />
        <ExportHistory locale={locale} locales={locales} />
        <SustainComp locale={locale} locales={locales} />
        {/* <HandmadeComp locale={locale} locales={locales} /> */}
      </Layout>
    </>
  )
}

export default AboutPage

export const getStaticProps = (ctx) => {
  let { locale, locales } = ctx
  return { props: { locale, locales }, revalidate: 60 }
}
